module.exports = __webpack_public_path__ + "img/R6__1242.3af4a263.jpeg";